import { DiToken } from '@bcf-vanilla-ts-v1-shared/di/di-token';

// biome-ignore lint/style/useNamingConvention: must be that way
export const COOKIE_CONSENT_DISABLED: DiToken<boolean> = new DiToken<boolean>('cookieConsentDisabled');

// biome-ignore lint/style/useNamingConvention: must be that way
export const COOKIE_CONSENT_DISABLED_DEFAULT_VALUE: boolean = false;
